import { ListenableSubscribable } from '@benzinga/subscribable';
import { deepEqual } from '@benzinga/utils';

export interface UserStoreEvent {
  type: 'user_settings:stored';
  settings: Record<string, object>;
}

export class UserStore extends ListenableSubscribable<UserStoreEvent> {
  private date?: Date;
  private settings?: Record<string, object>;

  public shouldUpdateUserSettings = (): boolean => {
    const ONE_MIN = 60 * 1000; /* ms */
    const lastCalled = this.date?.getTime() ?? 0; // use this once all watchlist are grabbed from manager
    if (this.settings === undefined || Date.now() - lastCalled > ONE_MIN) {
      return true;
    }
    return false;
  };

  public setUserSettings = (globalSettings: Record<string, object>): void => {
    this.date = new Date();
    if (!deepEqual(this.settings, globalSettings)) {
      this.settings = globalSettings;
      this.dispatch({
        settings: this.settings,
        type: 'user_settings:stored',
      });
    }
  };

  public getUserSettings = (): Record<string, object> | undefined => {
    return this.settings;
  };
}
